import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-cs-toaster',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cs-toaster.component.html',
  styleUrl: './cs-toaster.component.scss',
  encapsulation: ViewEncapsulation.None

})
export class CsToasterComponent {

}
